import { GroupeVarietalVariete } from './groupe-varietal-variete.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class GroupeVarietalParam {
    static jsonMap = {
        id: 'id',
        code: 'code',
        libelle: 'libelle',
        varietes: { key: 'varietes', converter: new (ArrayClassConverterFactory.build(GroupeVarietalVariete))() }
    };

    id: number;
    code: string;
    libelle: string;
    varietes: GroupeVarietalVariete[] = [];
}
